module.exports = __webpack_public_path__ + "static/media/playertable icon-1.21365c0d.svg";